module.exports = __webpack_public_path__ + "img/desktop_reagendamiento_reagendado.4e57fe80.png";